import type { TypedClient } from '@platform/openapi';
import { SessionGate } from './SessionGate.tsx';
import { Shell } from './Shell.tsx';

export const AuthenticatedShell = ({ api }: { api: TypedClient }) => (
  <SessionGate>
    <Shell api={api} />
  </SessionGate>
);
